export default "__VITE_ASSET__jqCDDTvP__"